import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const fadeIn = useFadeIn();
  const packs = [{
    emoji: '📘',
    title: 'Volume 1 — Attention & Focus Training Center',
    subtitle: 'Find The Difference, Hidden Objects, Maze Challenges, Focus Missions & more',
    desc: '★ Your child learns to stay on task and finish what they start.',
    color: 'border-blue-300 bg-blue-50',
    accent: 'text-blue-600'
  }, {
    emoji: '📗',
    title: 'Volume 2 — Memory Booster Lab',
    subtitle: 'Memory Cards, Sequence Challenges, Memory Grids, Recall Missions & more',
    desc: '★ Your child remembers faster and retains everything they learn.',
    color: 'border-green-300 bg-green-50',
    accent: 'text-green-600'
  }, {
    emoji: '📙',
    title: 'Volume 3 — Learning Skills Workshop',
    subtitle: 'Sorting, Pattern Recognition, Early Math Thinking, Skill Builders & more',
    desc: '★ Your child learns HOW to learn — the skill that makes everything else easier.',
    color: 'border-orange-300 bg-orange-50',
    accent: 'text-orange-600'
  }, {
    emoji: '📕',
    title: 'Volume 4 — Thinking & Problem Solving Center',
    subtitle: 'Logic Puzzles, Brain Teasers, Detective Problems, Mystery Challenges & more',
    desc: '★ Your child becomes a confident, independent thinker.',
    color: 'border-red-300 bg-red-50',
    accent: 'text-red-600'
  }, {
    emoji: '📒',
    title: 'Volume 5 — Calm & Self-Control Academy',
    subtitle: 'Breathing Exercises, Emotion Games, Mindfulness Activities, Confidence Builders & more',
    desc: '★ Your child becomes calmer, more patient and emotionally stronger.',
    color: 'border-purple-300 bg-purple-50',
    accent: 'text-purple-600'
  }, {
    emoji: '📓',
    title: 'Volume 6 — Brain Power Playground',
    subtitle: 'Mixed Challenges, Timed Activities, Multi-Skill Missions, Ultimate Brain Games & more',
    desc: "★ Your child's full brain fires together — fast, flexible and confident.",
    color: 'border-pink-300 bg-pink-50',
    accent: 'text-pink-600'
  }];
  return <section className="py-10 md:py-16 px-4 bg-gray-50" data-id="element-253">
      <div className="max-w-3xl mx-auto" data-id="element-254">
        <div ref={fadeIn.ref} className={`text-center ${fadeIn.className}`} data-id="element-255">
          <h2 className="text-2xl md:text-5xl font-black text-gray-900 mb-8 md:mb-10" data-id="element-256">
            📚 What's Inside The Little Genius System™
          </h2>

          <div className="space-y-4 md:space-y-6 mb-8 md:mb-12" data-id="element-257">
            {packs.map((pack, i) => <div key={i} className={`${pack.color} border-2 rounded-2xl p-5 md:p-8 text-left shadow-sm`} data-id="element-258">
                <div className="flex items-start gap-4" data-id="element-259">
                  <span className="text-3xl md:text-4xl flex-shrink-0" data-id="element-260">
                    {pack.emoji}
                  </span>
                  <div data-id="element-261">
                    <h3 className={`text-xl md:text-2xl font-black ${pack.accent} mb-1`} data-id="element-262">
                      {pack.title}
                    </h3>
                    <p className="text-base md:text-lg font-bold text-gray-900 mb-2" data-id="element-263">
                      {pack.subtitle}
                    </p>
                    <p className="text-sm md:text-lg text-gray-600 font-medium" data-id="element-264">
                      {pack.desc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="max-w-md mx-auto" data-id="element-265">
            <CTAButton text="👉 GET THE SYSTEM NOW" data-id="element-266" />
          </div>
        </div>
      </div>
    </section>;
}